<template>
  <PConfirmeSeuCodigo />
</template>

<script>
import PConfirmeSeuCodigo from '@/components/p-confirme-seu-codigo/index.vue';

export default {
  components: {
    PConfirmeSeuCodigo,
  },
};
</script>
